<!-- @if (shouldShowLeft()) {
  <div class="Left" #left style="
  position: absolute;
  left: 0;
  height: 39px;
  overflow: hidden;
  width: 24px;
  z-index: 999;
  top: 9px;
  "><div style="
  height: 100%;
  box-shadow: 1px 0px 5px 2px #3d3d3d8c;
  margin-right: 10px;
  "></div></div>
} -->

<!-- @if (shouldShowRight()) {
  <div class="Right" style="
    position: absolute;
    right: 0;
    height: 39px;
    overflow: hidden;
    width: 24px;
    z-index: 999;
    top: 9px;
  ">
    <div style="
    height: 100%;
    width: 100%;
    box-shadow: -1px 0px 5px 2px #3d3d3d8c;
    margin-left: 10px;
  "></div>
  </div>
} -->
<div #progressContainer class="ProgressContainer Flexbox Align--center" [style.--largest-pointy]="largestPointy" [style.--progress-container-width]="containerWidth" [style.--progress-item-count]="indexedViews.length">
  @for (view of indexedViews; track $index; let i = $index) {
    @if (!view.isHidden) {
      <div class="Pointy" #pointy [class.ActiveIndex]="activeVieiwIndex === i" [attr.data-index]="i">
        <div class="PointyContent Flexbox Align--center Justify--center" [class.Completed]="doesSectionHaveSelection(view.title)">
          <button mat-button (click)="progressItemClick(i)">
            <p>{{ view.displayTitle ?? view.title }}</p>
          </button>
        </div>
      </div>
    }
  }
</div>
